const toggleFooterMenu = ( ( document ) => {
	const _toggleMenu = () => {
		const toggleBtns = document.querySelectorAll( '[rel="open-menu-box"]' );
		const menuBoxes = document.querySelectorAll( '[rel="menu-box"]' );
		toggleBtns.forEach( ( toggleBtn ) => {
			toggleBtn.addEventListener( 'click', ( e ) => {
				// console.log( 'clicked' );
				const menuBox =
					toggleBtn.parentElement.querySelector( '[rel="menu-box"]' );
				if ( e.target.classList.contains( 'is-active' ) ) {
					toggleBtn.classList.remove( 'is-active' );
					menuBox.classList.remove( 'is-active' );
					return;
				}
				toggleBtn.classList.toggle( 'is-active' );

				menuBoxes.forEach( ( menu ) => {
					menu.classList.remove( 'is-active' );
				} );
				menuBox.classList.add( 'is-active' );
			} );
		} );
	};
	const init = () => {
		_toggleMenu();
	};

	return {
		init,
	};
} )( document );

export default toggleFooterMenu;
